<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
    />

    <!--점검정보-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot" /> 점검정보</h5>
      </vs-col>
    </vs-row>
    <div class="writeGridContainer mt-4">
      <div>
        <div>점검일</div>
        <span v-if="isPrint" class="print-input"> {{ form.checkDate }} </span>
        <date-selector v-else v-model="form.checkDate" :readonly="board.readonly" />
      </div>
      <div>
        <div>점검장소</div>
        <p v-if="isPrint" class="print-input">{{ form.checkLocation }}</p>
        <ml-input v-else v-model="form.checkLocation" :readonly="board.readonly" />
      </div>
      <div>
        <div>면적</div>
        <p v-if="isPrint" class="print-input">{{ form.landSize }}</p>
        <comma-input v-else v-model="form.landSize" type="number" :readonly="board.readonly" />
        <p class="pl-2">m<sup>2</sup></p>
      </div>
      <div>
        <div>층수 (지하/지상)</div>
        <p v-if="isPrint" class="print-input">{{ form.belowGroundFloors }} / {{ form.aboveGroundFloors }}</p>
        <div v-else class="flex items-center gap-3">
          <ml-input class="w-full" v-model="form.belowGroundFloors" :readonly="board.readonly" />
          <span>/</span>
          <ml-input class="w-full" v-model="form.aboveGroundFloors" :readonly="board.readonly" />
        </div>
      </div>
      <div>
        <div>점검대상 건물용도</div>
        <p v-if="isPrint" class="print-input">{{ form.buildingType }}</p>
        <ml-input v-else v-model="form.buildingType" :readonly="board.readonly" />
      </div>

      <div>
        <div>점검자</div>
        <p v-if="isPrint" class="print-input">소속 : {{ form.department }} / 성명 : {{ form.checkerName }}</p>
        <div v-else class="flex items-center gap-4">
          <span>소속</span>
          <ml-input v-model="form.department" class="w-full flex-1" :readonly="board.readonly" />
          <span>성명</span>
          <ml-input v-model="form.checkerName" class="w-full flex-1" :readonly="board.readonly" />
        </div>
      </div>
      <div>
        <div>점검여부</div>
        <p v-if="isPrint" class="print-input">{{ form.checkStatus }}</p>
        <label v-else class="flex items-center"> <vs-checkbox v-model="form.checkStatus" vs-value="이행" :readonly="board.readonly" /> 이행 </label>
      </div>
    </div>

    <!-- 기타 관계법령에 따른 안전점검 -->
    <table-custom
      :board="board"
      :is-print="isPrint"
      title="기타 관계법령에 따른 안전점검"
      :tableData="[
        { id: 'input1', title: '연번', type: 'no', width: '80px'},
        { id: 'input2', title: '점검대상', type: 'text', placeholder: '내용' },
        { id: 'input3', title: '점검방법', type: 'text', placeholder: '내용' },
        { id: 'input4', title: '이전 검사일', type: 'text', placeholder: '내용' },
        { id: 'input5', title: '점검시기', type: 'text', placeholder: '내용' },
        {
          id: 'input6',
          title: '점검자',
          type: 'select',
          selectData: [
            '자체',
            '용역',
          ],
          placeholder: '선택',
        },
        { id: 'input7', title: '근거법령', type: 'text', placeholder: '내용' },
      ]"
      v-model="form.worker"
      :mobile="['input2', 'input4', 'input6']"
    />

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>

  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import TableCustom from "@/components/TableCustom.vue";

export default {
  components: {
    TableCustom,
    DateSelector,
    PhotoUploadGridModule,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      showPopup: false,
      form: {
        stdInfo: {},
        fileList: [],

        checkDate: "", // 점검일
        checkLocation: "", // 점검장소
        landSize: "", // 면적
        belowGroundFloors: "", // 층수 (지하)
        aboveGroundFloors: "", // 층수 (지상)
        buildingType: "", // 건물용도
        department: "", // 소속
        checkerName: "", // 성명
        checkStatus: "", // 점검여부

        worker: [{}], // 1줄을 보여주기 위해 빈데이터 {} 추가
      },
    };
  },
  methods: {
  },
};
</script>

<style scoped lang="scss">

</style>
